<template>
  <div>
    <b-notification :has-icon="true" icon="info" :closable="false">
      <p>
        <span v-html="$t('compCarbonFormsBuildingsHelpManual.text-1')" />
        <br /><br />
        <span v-html="$t('compCarbonFormsBuildingsHelpManual.text-2')" />
        <br />
        <span v-html="$t('compCarbonFormsBuildingsHelpManual.text-3')" />
        <br />
        <span v-html="$t('compCarbonFormsBuildingsHelpManual.text-4')" />
      </p>
      <div class="has-text-centered">
        <img
          src="@/assets/images/geshelp/doc_aide_fuites-refrigeration.png"
          width="600"
          height="142"
        />
      </div>
      <p class="has-text-centered">
        Source:
        <a
          class="link"
          target="_blank"
          href="http://www.bilans-ges.ademe.fr/fr/accueil/documentation-gene"
          >http://www.bilans-ges.ademe.fr/fr/accueil/documentation-gene</a
        >
      </p>
    </b-notification>
    <help-data />
  </div>
</template>

<script>
export default {
  name: 'HelpManual',
  components: {
    'help-data': () =>
      import('@/components/carbon/forms/buildings/HelpData.vue')
  }
}
</script>
